import { render, staticRenderFns } from "./fraudplusreport.vue?vue&type=template&id=412b5f7f"
import script from "./fraudplusreport.vue?vue&type=script&lang=js"
export * from "./fraudplusreport.vue?vue&type=script&lang=js"
import style0 from "./fraudplusreport.vue?vue&type=style&index=0&id=412b5f7f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports